import type { FaireProductEntity } from "../../entity_types/product";

export const p_yjyhx96bs2: FaireProductEntity = {
  token: "p_yjyhx96bs2",
  type: "product",
  name: "christmas mugs notecard",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl: "https://cdn.faire.com/fastly/07457171efce5d7569cbb751f87cfa337a683bc2fe1e9765a7be8a98268772df.jpeg",
  galleryImageUrls: [],
  priceDollars: 11.5,
  description: "Send sweet greetings to your coffee and tea-loving friends this Christmas season. These notecards are blank inside with charming watercolor illustrations of Christmas mugs on the front. \n\nDetails:\n\n * set of eight (or single) folded cards with envelopes \n * blank inside \n * 5.5 inch x 4.25 inch \n * printed on 120lb superfine paper\n\n * original artwork by Emily Lex ",
  tags: [],
  msrpDollars: 23,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-28T05:30:13.278Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
